import { defineStore } from 'pinia'
import { services, getHeader } from '@/assets/js/config.js'
import axios from 'axios'

export const useCreditReportStore = defineStore('creditReportStore', {
	state: () => ({
		creditReportSummary: {},
		creditReportList: [],
		creditReportPagination: {}
	}),
	getters: {
		// list_angkasa_item_details() {
		// 	const creditReportSummary = localStorage.getItem('current-credit-report-summary');
		// 	if(_gHlp.isEmpty(creditReportSummary) || _gHlp.isEmpty(creditReportSummary.credit_report_summary.angkasa_reports)) return [];
		// 	const angkasa = creditReportSummary.credit_report_summary.angkasa_reports;
		// 	const flattenedSubItems = angkasa.flatMap(obj => 
		// 			Object.values(obj).flatMap(innerArr => 
		// 				innerArr.aks_rep_items.map(item => item.aks_rep_itm_details)
		// 			)
		// 	);
		// 	return flattenedSubItems;
		// },
		// list_trade_ref() {
		// 	return !_gHlp.isEmpty(this.creditReportSummary) ? this.creditReportSummary.credit_report_summary.trade_references : [];
		// },
		// list_special_attension() {
		// 	return !_gHlp.isEmpty(this.creditReportSummary) ? this.creditReportSummary.credit_report_summary.special_attensions : [];
		// },
	},
	actions: {
		async getCreditReportSummary(params) {
			return new Promise((resolve, reject) => {
				axios.get(services.commitment + 'credit-report/summary', {
					params: params,
					headers: getHeader()
				}).then(res => {
					if (!_gHlp.isEmpty(res.data)) {
						this.creditReportSummary = res.data;
					} else {
						this.creditReportSummary = {}
					}
					resolve(this.creditReportSummary);
				}).catch(error => {
					_gNotif.errorFunction(error);
					reject(error); // Reject the Promise with the error
				});
			});
		},
		async saveAllAngkasaItems(items, credit_report_id = null, customer_id = null) {
			try {
				let params = {
					credit_report_id: credit_report_id,
					credit_report_cust_id: customer_id,
					angkasa_item_details: items
				};
				return await axios.post(services.commitment + 'credit-report/bulk-save-angkasa', params, { headers: getHeader() })
					.then(res=>{
						return res.data;
					})
					.catch(e=>{
						_gNotif.errorFunction(e)
					});
			} catch (error) {
				_gNotif.errorFunction(error);
				return null;
			}

		},
		async saveAllTradeRefItems($items, $credit_report_id = null, $customer_id = null) {
			return new Promise((resolve, reject) => {
				let params = {
					credit_report_id: $credit_report_id,
					credit_report_cust_id: $customer_id,
					trade_ref_items: $items
				}
				axios.post(services.commitment + 'credit-report/bulk-save-trade-ref', params, { headers: getHeader() })
					.then(res => {
						resolve(res);
					}).catch(e => {
						_gNotif.errorFunction(e)
						reject(error);
					});
			});
		},
		async deleteAngkasaItems(angkasa_ids) {
			if (_gHlp.isEmpty(angkasa_ids)) return false;

			let axiosCalls = [];
			for (let i = 0; i < angkasa_ids.length; i++) {
				const id = angkasa_ids[i];
				axiosCalls.push(axios.delete(services.commitment + 'credit-report/delete-angkasa/' + id, { headers: getHeader() }))
			}
			return Promise.all(axiosCalls)
		},
		async deleteTradeRefItems(trade_ref_ids) {
			if (_gHlp.isEmpty(trade_ref_ids)) return false;

			let axiosCalls = [];
			for (let i = 0; i < trade_ref_ids.length; i++) {
				const id = trade_ref_ids[i];
				axiosCalls.push(axios.delete(services.commitment + 'credit-report/delete-trade-ref/' + id, { headers: getHeader() }))
			}
			return Promise.all(axiosCalls)
		}
	}
})